namespace AgerLMS.LMS {
    export interface UserVideoFileRow {
        Id?: number;
        LessonId?: number;
        OrderItemId?: number;
        VideoResolution?: VideoResolutions;
        FileStatus?: FileStatus;
        OriginalFileUploadUrl?: string;
        WatermarkTimeList?: string;
        TryCount?: number;
        LockExpiration?: string;
        LastErrorMessage?: string;
        FileSize?: number;
        RenderWorker?: string;
        WatchExpired?: boolean;
        FileDeleted?: boolean;
        FileDeleteDate?: string;
        RenderStartDate?: string;
        RenderEndDate?: string;
        LessonCourseId?: number;
        LessonName?: string;
        LessonCourseName?: string;
        LessonCoursePublishDate?: string;
        OrderItemInsertDate?: string;
        OrderItemUsagePeriod?: number;
        OrderItemWatchCount?: number;
        OrderItemUserId?: number;
        WatchEndDate?: string;
        WatchCount?: number;
        IsWatchExpired?: YesNo;
        IsFileDeleted?: YesNo;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace UserVideoFileRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OriginalFileUploadUrl';
        export const localTextPrefix = 'LMS.UserVideoFile';
        export const deletePermission = 'Logging:UserVideoFile:Modify';
        export const insertPermission = 'Logging:UserVideoFile:Modify';
        export const readPermission = 'Logging:UserVideoFile:Read';
        export const updatePermission = 'Logging:UserVideoFile:Modify';

        export declare const enum Fields {
            Id = "Id",
            LessonId = "LessonId",
            OrderItemId = "OrderItemId",
            VideoResolution = "VideoResolution",
            FileStatus = "FileStatus",
            OriginalFileUploadUrl = "OriginalFileUploadUrl",
            WatermarkTimeList = "WatermarkTimeList",
            TryCount = "TryCount",
            LockExpiration = "LockExpiration",
            LastErrorMessage = "LastErrorMessage",
            FileSize = "FileSize",
            RenderWorker = "RenderWorker",
            WatchExpired = "WatchExpired",
            FileDeleted = "FileDeleted",
            FileDeleteDate = "FileDeleteDate",
            RenderStartDate = "RenderStartDate",
            RenderEndDate = "RenderEndDate",
            LessonCourseId = "LessonCourseId",
            LessonName = "LessonName",
            LessonCourseName = "LessonCourseName",
            LessonCoursePublishDate = "LessonCoursePublishDate",
            OrderItemInsertDate = "OrderItemInsertDate",
            OrderItemUsagePeriod = "OrderItemUsagePeriod",
            OrderItemWatchCount = "OrderItemWatchCount",
            OrderItemUserId = "OrderItemUserId",
            WatchEndDate = "WatchEndDate",
            WatchCount = "WatchCount",
            IsWatchExpired = "IsWatchExpired",
            IsFileDeleted = "IsFileDeleted",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
